import { render, staticRenderFns } from "./quotation-view.vue?vue&type=template&id=45337c8a&scoped=true&"
import script from "./quotation-view.vue?vue&type=script&lang=js&"
export * from "./quotation-view.vue?vue&type=script&lang=js&"
import style0 from "./quotation-view.vue?vue&type=style&index=0&id=45337c8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45337c8a",
  null
  
)

export default component.exports